**Deprecated:** This field is ignored and can be safely omitted.
